import { cep, createValidator, ErrorObject, maxLength } from 'util/validation'
import { microarea } from 'util/validation/rules/microarea'

import { InativacaoImoveisBuscaFormModel } from './model-inativacaoImoveis'

export const validateInativacaoImoveisBuscaForm = createValidator<InativacaoImoveisBuscaFormModel>(
  {
    cep: [cep],
    logradouro: [maxLength(72)],
    microarea: [microarea],
  },
  (values: InativacaoImoveisBuscaFormModel, errors: ErrorObject<InativacaoImoveisBuscaFormModel>) => {
    if (values.cep && !values.logradouro) {
      errors.logradouro = 'Campo obrigatório quando o CEP é informado.'
    }

    return errors
  }
)
